import { render, staticRenderFns } from "./DownloadResource.vue?vue&type=template&id=bb1b40c0&"
import script from "./DownloadResource.vue?vue&type=script&lang=js&"
export * from "./DownloadResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports